import axios from 'axios'
import data from '../data/courseList'
import CONFIG from '../utils/config'
import { objectToFormData } from './data'
import { useNavigate as navigate } from "react-router-dom";
import API_LIST from '../utils/apiList';

export const getUserCourses = async (payload) => {
  const url = CONFIG.API_URL + API_LIST.API_ROUTES.BASE_PATH + "?module=" + payload.module + "&token=" + payload.token
  return axios({
    method: "GET",
    url,
  }).then(response => {
    // console.log(response.data)
    if (response.data.status) {
      return {
        status: 'success',
        payload: response.data.data
      }
    } else {
      if (response.data.message === 'Token is not valid') {
        alert("Your Session is Logged Out. Please Sign in.")
        window.alert = () => false
        localStorage.clear()
        window.open(CONFIG.SESSION_EXPIRED_URL, "_self");
      }
      return {
        status: 'error',
        error: {
          message: response.data.message
        }
      }
    }
  }).catch((error) => {
    // console.log("errorData", error.respoinse);
    if (error.response != undefined && error.response?.status === 401) {
      alert("Your Session is Logged Out. Please Sign in.")
      window.alert = () => false
      localStorage.clear();
      window.open(CONFIG.SESSION_EXPIRED_URL, "_self");
      navigate("/", { sessionExpired: true });
    }
    return {
      status: 'error',
      error
    }
  })
}